export const printmode = {
  printmodeHeader: "Modes d’impression | Mode d’impression | {n} modes d’impression",
  printmodeMethodHeader: "Procédé | Procédés | {n} procédés",
  printmodeMaterialHeader: "Matériau | Matériaux | {n} matériaux",
  actions: {
    createNew: "Créer un nouveau",
    update: "Sauvegarder"
  },
  name: "Nom",
  basicFeatures: "Caractéristiques de base",
  description: "Description",
  surfaceQuality: "Aspect de la surface",
  applications: "Applications",
  ranking: "Classement",
  rankingLabels: {
    price: "Qualité-prix",
    flexibility: "Flexibilité",
    stability: "Stabilité",
    precision: "Précision",
    wearResistance: "Résistance à l’abrasion",
    heatResistance: "Résistance aux hautes températures"
  },
  technicalFeatures: "Données techniques",
  technicalFeaturesLabels: {
    resolutionXY: "Résolution X et Y",
    resolutionZ: "Résolution Z",
    minFeatureSize: "Épaisseur minimale des parois",
    maxNumberOfParts: "Nombre maximal de pièces",
    maxDimensions: "Dimensions maximales de la pièce",
    maxDimensionLabels: {
      x: "X",
      y: "Y",
      z: "Z"
    },
    maxIncrementalMeasurement: "Dimension de la chaîne"
  },
  maxDimensions: "Dimension de la pièce",
  maxDimensionLabels: {
    x: "X",
    y: "Y",
    z: "Z"
  },
  color: "Couleur",
  availableColorsavailableColors: "Couleurs",
  chooseColor: "Couleur",
  availableSurfaceFinishes: "Finitions",
  colorLabels: {
    name: "Nom de la couleur",
    variableName: "Variable excel",
    hue: "Teinte",
    thumbnail: "Vignette",
    hexcode: "Employer un code hexadécimal",
    choose: "Sélectionner",
    create: "Ajouter d’autres couleurs",
    delete: "Supprimer la couleur",
    uploadImage: "Télécharger l’illustration",
    replaceImage: "Bild Ersetzen"
  },
  material: "Matériau",
  materialLabels: { choose: "Sélectionner le matériau", createMaterial: "Créer un nouveau matériau", create: "Créer" },
  method: "Procédé",
  methodLabels: { choose: "Sélectionner le procédé", createMethod: "Créer un nouveau procédé", create: "Créer" },
  whiteLabels: "Marques blanches",
  whiteLabelLabels: {
    choose: "Quelles sont les marques blanches qui peuvent commander ce procédé?",
    createWhiteLabel: "Créer une nouvelle marque blanche",
    create: "Créer"
  },
  processingSteps: {
    header: "Étapes suivantes",
    choose: "Quelles sont les étapes suivantes disponibles pour ce processus?"
  },
  testPricing: "Calculation du prix",
  testPricingLabels: {
    test: "Calculer les prix",
    paramLabels: {
      params: "Paramètres de test",
      dimensionX: "Dimension X",
      dimensionY: "Dimension Y",
      dimensionZ: "Dimension Z",
      internalVolume: "Volume",
      externalVolume: "Volume externe",
      surfaceArea: "Surface",
      minX: "Épaisseur de paroi minimale",
      maxX: "Épaisseur de paroi X maximale",
      maxY: "Épaisseur de paroi Y maximale"
    }
  },
  spreadSheetLabels: {
    defaultWhiteLabelName: "Standard",
    upload: "Télécharger le tableau excel",
    replace: "Remplacer le tableau excel",
    delete: "Effacer",
    calculatedPrice: "Prix calculé",
    commission: "Commission",
    standardPrice: "En standard",
    asStandard: "En standard",
    isPrintable: "Impression possible",
    isNotPrintable: "Pas d’impression possible",
    isTooSmall: "Pièce éventuellement trop petite",
    isTooLarge: "Pièce trop grande",
    productionTime: "Temps de production",
    productionTimeDays: "0 jour  | 1 jour | {n} de jours",
    spreadSheetMissing: "Aucun tableau excel standard enregistré",
    confirmDeleteHeadline: "Effacer le tableau excel",
    confirmDeleteMessage: 
      "Voulez-vous vraiment <strong>effacer</strong> ce tableau Excel?<br> Cette action est irréversible.",
    cancel: "Annuler"
  }
};
